/*
  Dtcs state
*/
export default {
  loading: false,
  eventList: [],
  eventDictList: [],
  timeList: {
    today: [],
    yesterday: [],
    thisWeek: [],
    lastWeek: []
  }
}
